import React from 'react';

const SvgQrCode: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g strokeLinecap="round" fillRule="evenodd" strokeLinejoin="round">
        <path d="M8 9H4a1 1 0 01-1-1V4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM8 21H4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM20 9h-4a1 1 0 01-1-1V4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1z" />
      </g>
      <path strokeLinecap="round" strokeLinejoin="round" d="M7 12h2" />
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 5V3M16 12h-3a1 1 0 01-1-1V9M4 12H3M15 18h-2a1 1 0 00-1 1v2M12 15h6M21 15v5a1 1 0 01-1 1h-5M6 5.99c-.003 0-.005.002-.005.005S5.997 6 6 6s.005-.002.005-.005S6.003 5.99 6 5.99M17.995 5.995c-.003 0-.005.002-.005.005s.002.005.005.005S18 6.003 18 6s-.002-.005-.005-.005M18.995 11.995c-.003 0-.005.002-.005.005s.002.005.005.005S19 12.003 19 12s-.002-.005-.005-.005" />
        <path d="M17.995 17.995c-.003 0-.005.002-.005.005s.002.005.005.005S18 18.003 18 18s-.002-.005-.005-.005M6.005 17.995c-.003 0-.005.002-.005.005s.002.005.005.005.005-.002.005-.005-.002-.005-.005-.005" />
      </g>
    </svg>
  );
};

export default SvgQrCode;
